export const image_categories = {
    A: "Exterior",
    BA: "Bar",
    BD: "Bathroom Example",
    EK: "Shopping",
    F: "Sports and leisure",
    FAD: "Adventure",
    FO: "Folklore",
    FRE: "Relax",
    FRR: "Breakfast Room",
    GA: "Garden",
    HB: "Indoor Pool",
    IT: "Internet Café",
    K: "Conference Room",
    KL: "Culture",
    KU: "Art",
    L: "Lounge / Lobby",
    LG: "Logo",
    LK: "Map",
    LS: "Landscape",
    LU: "Aerial Photograph",
    MF: "Rental Car / Vehicle",
    MHS: "Sea / Harbour / Ship",
    MOD: "Model Impression",
    P: "Outdoor Pool",
    PE: "People",
    PEF: "Family",
    PEH: "Wedding",
    PEK: "Children",
    PEP: "Couple",
    PER: "Romance",
    PEY: "Party",
    PR: "Price",
    R: "Restaurant",
    S: "Beach",
    SD: "Deck of Ship",
    SE: "Point of Interest",
    STA: "City",
    TE: "Terrace",
    TI: "Pets",
    W: "Room Example",
    WEL: "Health & Beauty",
    X: "Miscellaneous",
};

const _category_list = [];

for (let c in image_categories) _category_list.push(c);

export const category_list = _category_list;
